<!--
 * @Author: your name
 * @Date: 2020-06-29 16:10:51
 * @LastEditTime: 2020-07-27 16:57:12
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \heating-wechat-web\src\components\Index\Index.vue
--> 
<template>
  <div class="warrantyInfo-wrap"
    v-loading="loading"
    element-loading-text="正在查询您的报修记录，请稍等">
    <div class="warrantyInfo-back"></div>
    <div class="warrantyInfo-top">
      <div style="display: flex;justify-content: space-between;">
        <div style="padding: 0.15rem 0rem 0.05rem 0.2rem;">
          <div>工单编号：{{wxWarrantyInfo[0].work_order_id}}</div>
          <div style="margin-top: 0.1rem;">报修类型：{{wxWarrantyInfo[0].maintain_type}}</div>
        </div>
        <div>
          <div class="box" :style="{color:imgInfo.color,background:imgInfo.backgroundColor,border:imgInfo.border}">{{imgInfo.statusName}}</div>
        </div>
      </div>
      <div style="padding: 0rem 0rem 0.15rem 0.2rem;">
        <div style="display:flex;margin-top: 0.05rem;" class="textBox">
          <div style="width: 0.75rem;">报修内容：</div>
          <div style="width: 2.3rem;">{{wxWarrantyInfo[0].maintain_content}}</div>
        </div>
        <div style="margin-top: 0.1rem;">报修时间：{{wxWarrantyInfo[0].submit_time | dateFilter}}</div>
      </div>
    </div>
   
    <div class="feedback-content">
      <div v-if="replayFalg">
        <div class="boxborder-left"></div>
        <!-- 步骤点1 -->
        <div class="warranty-parent" v-for="item in wxWarrantyInfo" :key="item.id" >
          <div style="display: flex;">
            <div style="width: 0.16rem;height:0.16rem;margin-left:0.025rem"><img src="../../../assets/image/step.png" alt="" width="100%" height="100%" style="margin-top:0.02rem"></div>
            <div style="margin-left: 0.2rem;">{{item.update_time}}</div>
          </div>
          <!-- 受理 -->
          <div class="warranty-accepted">
              <div class="warranty-content-box">
                <div>
                  <div style="width: 0.12rem;height:0.12rem;margin-right:0.05rem">
                    <img :src="item.status_img_src"  alt="" style="width: 100%;height:100%">
                  </div>
                  <div><span style="font-size: 0.12rem;">{{item.status_name}}</span></div>
                </div>
                <div style="display: flex;">
                  <div style="width: 0.45rem;">内容：</div>
                  <div>{{item.work_reply}}</div>
                </div>
              </div>
          </div>
        </div>
      </div>
      <div v-else style="position: absolute;top:0.5rem;width:calc(100% - 0.4rem);text-align: center;">
        暂无回复
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment';

export default {
  name: 'warrantyInfo',
  data(){
    return{
     imgIndexOf:'',// 当前工单的状态
     wxWarrantyInfo:[{}],// 工单详情
     loading:true,
     replayFalg:false,
     imgInfo:{},// 工单状态的样式信息
    }
  },

  methods:{
    // 查看当前的订单信息
    async getWarrantyOrder(workOrderId){
      const res = await this.$http.get(`${this.$url.globalurl}/wxWarranty/${workOrderId}`);
      if(res.code === 200){
        const orderNumber = '000000';
        if(res.result){
          res.result.forEach(i=>{
            i.update_time = moment(i.update_time).format('YYYY-MM-DD HH:mm:ss');
            i.status_img_src = require('../../../assets/image/' + i.status_img_src);
            i.work_order_id = moment().format('YYYYMMDD') + orderNumber.slice(0,-i.work_order_id.length) + i.work_order_id;
          })
          this.replayFalg = true;
        }
        this.wxWarrantyInfo = res.result;
        this.imgIndexOf = res.result[0].maintain_status_id;
        this.loading = false;
      }
    },
  },

  mounted(){
    this.imgInfo = {
      color:this.$route.query.color,
      backgroundColor:this.$route.query.backgroundColor,
      border:'solid 1px ' + this.$route.query.color,
      statusName:this.$route.query.statusName
    }
    this.getWarrantyOrder(this.$route.query.workOrderId);
    document.title = '报修详情';
  },
  filters:{
    dateFilter:function(date){
      return moment(date).format('YYYY-MM-DD HH:mm')
    },
  }
  
}
</script>
<style lang='scss' scoped>
@import url(warrantyInfo.scss);
</style>
